import React, { useMemo, useState } from "react";

import { isBefore, fromUnixTime, endOfMonth, endOfWeek } from "date-fns";

import styles from "./Map.module.scss";
import { EventCard, EventCardFragment } from "../../common/EventCard";
import { VenueCardFragment } from ".";
import { ActionButton } from "../../common/ActionButton";

interface EventsListingProps {
  events: Array<EventCardFragment & { venue?: VenueCardFragment }>;
}

enum EventsTab {
  Week,
  Month,
}

const EventsListing: React.FC<EventsListingProps> = ({ events }) => {
  const [tab, setTab] = useState<EventsTab>(EventsTab.Month);

  const cut = useMemo(() => {
    const compareD =
      tab === EventsTab.Month ? endOfMonth(new Date()) : endOfWeek(new Date());

    return events.filter(evt => {
      const d = fromUnixTime(parseInt(evt.earliest));

      return isBefore(d, compareD);
    });
  }, [events, tab]);

  return (
    <div className={styles.events}>
      <div className={styles.meta}>
        <ActionButton
          className={styles.metaBtn}
          active={tab === EventsTab.Week}
          notLast
          onClick={() => setTab(EventsTab.Week)}
        >
          Week
        </ActionButton>
        <ActionButton
          className={styles.metaBtn}
          active={tab === EventsTab.Month}
          onClick={() => setTab(EventsTab.Month)}
        >
          Month
        </ActionButton>
      </div>
      {cut.map(event => (
        <EventCard key={event.specific} {...event} />
      ))}

      {cut.length === 0 && (
        <span className={styles.empty}>No events currently</span>
      )}
    </div>
  );
};

export { EventsListing };
